import _ from "lodash";
import React from "react";
import classes from "./ScreenPanel.scss";
import ScreenHeader from "./ScreenHeader";
import Footer from "./Footer";
import classNames from "classnames";
import ModalHeader from "./ModalHeader";
import Header from "./Header";
import { getGlobalHeaderWiseScreenRevampStatus } from "Teacher/routes/Courses/routes/Course/modules/CourseModule";
class ScreenPanel extends React.PureComponent {
  constructor(props) {
    super(props);
    this.contentRef = React.createRef();
  }

  UNSAFE_componentWillMount = () => {
    document.addEventListener("mousedown", this.onOutSideClick);
  };

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.onOutSideClick);
  }

  onOutSideClick = e => {
    const {
      closeOnOutSideClick = false,
      onCloseClick,
      parentContainerRef,
    } = this.props;
    if (
      closeOnOutSideClick &&
      parentContainerRef?.current &&
      !parentContainerRef?.current?.contains(e.target)
    ) {
      e.stopPropagation();
      onCloseClick && onCloseClick();
    }
  };

  render() {
    const {
      children,
      screenTitle,
      onCloseClick,
      showBack,
      showScreenTitle,
      goToPreviousScreen,
      showPreview,
      footerComponent,
      isInnerModal,
      modalHeaderTitle,
      modalHeaderSubTitle = "",
      subTitleTextStyle = {},
      containerStyle = {},
      rightContainerContent,
      titleTextStyle,
      leftContainerStyles,
      rightContainerStyles,
      assessmentId,
      LETitle,
      assessmentType,
      showCustomHeaderIcon = false,
      customHeaderIcon = null,
      customHeaderIconStyle,
      titleContainerStyle = {},
      footerContainerStyle = {},
      onScroll,
      showNewDesign = false,
      showNewFooter = false,
      parentContainerRef,
      titleTextContainerStyle = {},
      headerContainerStyle = {},
      modalHeaderContainerStyle = {},
      scrollContainerStyle = {},
      screenHeaderContainerStyle = {},
      showNewHeaderDesign = false,
      headerRightComponent,
      showFooter = true,
      showHeader = true,
    } = this.props;

    const innerScrollContainer = classNames(
      { [classes.innerScrollContainer]: true },
      { [classes.modalInnerScrollContainer]: isInnerModal }
    );

    const onScrollLocal = e => {
      if (_.isFunction(onScroll)) onScroll(e);
    };

    const isGlobalHeaderEnabled = getGlobalHeaderWiseScreenRevampStatus();

    return (
      <div className={classes.container} ref={parentContainerRef}>
        {!isInnerModal && !showNewHeaderDesign && showHeader && (
          //Only for Full Screen Steps
          <ScreenHeader
            title={screenTitle}
            onBackClick={onCloseClick}
            showTitle={showScreenTitle}
            rightContainerContent={rightContainerContent}
            assessmentId={assessmentId}
            LETitle={LETitle}
            assessmentType={assessmentType}
            titleTextContainerStyle={titleTextContainerStyle}
            screenHeaderContainerStyle={screenHeaderContainerStyle}
            isGlobalHeaderEnabled={isGlobalHeaderEnabled}
          />
        )}
        {showNewHeaderDesign && !isInnerModal ? (
          <Header
            title={screenTitle}
            onBackClick={onCloseClick}
            headerRightComponent={headerRightComponent}
            isGlobalHeaderEnabled={isGlobalHeaderEnabled}
          />
        ) : null}
        {isInnerModal && (
          //Only for Modal Screen Steps
          <div
            className={classes.headerContainerStyle}
            style={{ ...containerStyle, ...headerContainerStyle }}
          >
            <ModalHeader
              title={modalHeaderTitle}
              subTitle={modalHeaderSubTitle}
              titleTextStyle={titleTextStyle}
              subTitleTextStyle={subTitleTextStyle}
              onCloseClick={onCloseClick}
              showBack={showBack}
              onBackClick={goToPreviousScreen}
              showPreview={showPreview}
              showCustomHeaderIcon={showCustomHeaderIcon}
              customHeaderIcon={customHeaderIcon}
              customHeaderIconStyle={customHeaderIconStyle}
              leftContainerStyles={leftContainerStyles}
              rightContainerStyles={rightContainerStyles}
              titleContainerStyle={titleContainerStyle}
              modalHeaderContainerStyle={modalHeaderContainerStyle}
            />
          </div>
        )}
        <div
          className={classes.scrollContainer}
          onScroll={onScrollLocal}
          style={scrollContainerStyle}
        >
          <div className={innerScrollContainer} style={{ ...containerStyle }}>
            {children}
          </div>
        </div>
        {footerComponent && showFooter && (
          <Footer
            footerComponent={footerComponent}
            containerStyle={containerStyle}
            footerContainerStyle={footerContainerStyle}
            showNewDesign={showNewDesign}
            showNewFooter={showNewFooter}
          />
        )}
      </div>
    );
  }
}

export default ScreenPanel;
